import BackendService from '@/services/Backend'
import buildURL from 'axios/lib/helpers/buildURL'

class PartnerWidgetService extends BackendService {
  constructor(baseUrl, interceptor) {
    super(baseUrl, 'partnerwidget', interceptor)
  }

  getBundle(code, language) {
    return this.get(`/public/bundles/${code}`, {}, false, { 'Accept-Language': language }).then(
      response => response.data
    )
  }

  getCustomThemeCssUrl(code, lastModifiedDate) {
    return Promise.resolve(buildURL(`${this.baseUrl}/public/bundles/${code}/css?v=${lastModifiedDate}`))
  }
}

export default PartnerWidgetService
